import React from "react";
import { Box, Typography, makeStyles } from "@material-ui/core";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ErrorIcon from "@material-ui/icons/ErrorOutline";

const useStyles = makeStyles((theme) => ({
  chip: {
    display: "inline-flex",
    alignItems: "center",
    borderRadius: 20,
    padding: theme.spacing(0.4, 0.9),
  },
  errorChip: {
    backgroundColor: "rgba(220, 38, 38, 0.1)",
    color: "#b91c1c",
  },
  upChip: {
    backgroundColor: "rgba(22, 163, 74, 0.1)",
    color: "#15803d",
  },
  downChip: {
    backgroundColor: "rgba(217, 119, 6, 0.1)",
    color: "#b45309",
  },
  icon: {
    fontSize: "0.9rem",
    marginRight: theme.spacing(0.5),
  },
  count: {
    fontWeight: 700,
    fontSize: "0.8rem",
    lineHeight: 1,
  },
  label: {
    fontSize: "0.68rem",
    color: theme.palette.text.secondary,
    opacity: 0.65,
    marginLeft: theme.spacing(0.75),
    lineHeight: 1.3,
  },
}));

const renderStatus = (classes, type, value) => {
  switch (type) {
    case "error":
      return (
        <Box className={`${classes.chip} ${classes.errorChip}`}>
          <ErrorIcon className={classes.icon} />
          <Typography className={classes.count}>{value}</Typography>
        </Box>
      );
    case "up":
      return (
        <Box className={`${classes.chip} ${classes.upChip}`}>
          <ArrowUpwardIcon className={classes.icon} />
          <Typography className={classes.count}>{value}</Typography>
        </Box>
      );
    case "down":
      return (
        <Box className={`${classes.chip} ${classes.downChip}`}>
          <ArrowDownwardIcon className={classes.icon} />
          <Typography className={classes.count}>{value}</Typography>
        </Box>
      );
    default:
      return null;
  }
};

const CardStatus = ({ type, title, value }) => {
  const classes = useStyles();

  return (
    <Box display="flex" alignItems="center" my={0.5}>
      {renderStatus(classes, type, value)}
      <Typography className={classes.label}>{title}</Typography>
    </Box>
  );
};

export default CardStatus;
